<template>
  <div class="color-picker-wrapper">
    <div @click="togglePicker">
      <!--取色器默认插槽按钮-->
      <slot>
        <div class="color-preview">
          <div class="color-swatch" :style="{ backgroundColor: displayColor }"></div>
          <span v-if="showValue" class="color-value">{{ displayValue }}</span>
          <span class="color-arrow">▼</span>
        </div>
      </slot>
    </div>
    <!--模态框需要对应的出现和隐藏动画-->
    <transition name="slide">
      <div v-if="showPicker" class="color-picker-popover">
        <div class="color-picker-cover" @click="closePicker"></div>
        <SketchPicker :value="colorObject" @input="handleColorChange" />
      </div>
    </transition>
  </div>
</template>

<script>
// 按需引入，减少打包体积
// 取色器路径：https://www.npmjs.com/package/vue-color/v/2.8.1
import { Sketch } from 'vue-color'

export default {
  name: 'ColorPicker',
  components: {
    SketchPicker: Sketch,
  },
  props: {
    value: {
      type: [String, Object],
      default: '#000000',
    },
    disableAlpha: {
      type: Boolean,
      default: false,
    },
    showValue: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      showPicker: false,
      localColor: this.value,
    }
  },
  computed: {
    // 转换为颜色选择器需要的对象格式
    colorObject() {
      return this.formatColorToObject(this.localColor)
    },

    // 显示的颜色值
    displayValue() {
      if (typeof this.localColor === 'string') {
        return this.localColor
      }
      return this.localColor.hex || '#000000'
    },

    // 显示的颜色
    displayColor() {
      if (typeof this.localColor === 'string') {
        return this.localColor
      }
      return this.localColor.hex || '#000000'
    },
  },
  watch: {
    value: {
      handler(newVal) {
        this.localColor = newVal
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {
    // 添加全局点击事件监听
    document.addEventListener('click', this.handleClickOutside)
  },
  beforeDestroy() {
    // 移除事件监听
    document.removeEventListener('click', this.handleClickOutside)
  },
  methods: {
    // 切换选择器显示状态
    togglePicker() {
      this.showPicker = !this.showPicker
    },

    // 关闭选择器
    closePicker() {
      this.showPicker = false
    },

    // 处理颜色变化
    handleColorChange(color) {
      this.localColor = color
      this.$emit('input', color)
      this.$emit('change', color)
    },

    // 将颜色格式化为对象格式
    formatColorToObject(color) {
      if (!color) {
        return { hex: '#000000' }
      }

      if (typeof color === 'string') {
        return { hex: color }
      }

      // 如果已经是对象格式，直接返回
      if (color.hex || color.rgb || color.hsl) {
        return color
      }

      return { hex: '#000000' }
    },

    // 处理点击外部区域
    handleClickOutside(event) {
      if (!this.$el.contains(event.target)) {
        this.closePicker()
      }
    },
  },
}
</script>

<style scoped lang="less">
.color-picker-wrapper {
  position: relative;
  display: inline-block;
  vertical-align: middle;
  /deep/ .vc-sketch-field {
    line-height: 20px !important;
    .vc-input__input {
      padding: 0;
      line-height: 20px !important;
      text-align: center;
      border-radius: 4px;
    }
  }
}

.color-preview {
  display: inline-flex;
  align-items: center;
  padding: 6px 12px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  cursor: pointer;
  background: white;
  transition: all 0.3s;
  min-width: 120px;
}

.color-preview:hover {
  border-color: #c0c4cc;
}

.color-swatch {
  width: 20px;
  height: 20px;
  border-radius: 3px;
  margin-right: 8px;
  border: 1px solid #f0f0f0;
  flex-shrink: 0;
}

.color-value {
  font-size: 14px;
  color: #606266;
  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.color-arrow {
  margin-left: 8px;
  font-size: 12px;
  color: #c0c4cc;
  transition: transform 0.3s;
}

.color-preview:hover .color-arrow {
  color: #909399;
}

.color-picker-popover {
  position: absolute;
  z-index: 2000;
  top: 100%;
  left: 0;
  margin-top: 4px;
}

.color-picker-cover {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
}
</style>
